<script setup>
import Section from "../internal/Section.vue";
import ReadonlyField from "../fields/ReadonlyField.vue";
import EditableField from "../fields/EditableField.vue";

defineProps({
  data: { type: Object, required: true },
  editMode: { type: Boolean, default: false },
  canEdit: { type: Boolean, default: false },
});

const emit = defineEmits(["update"]);

function setField(key, value) {
  emit("update", key, value);
}
</script>

<template>
  <div
    class="grid gap-4 grid-cols-[minmax(0,1.5fr)_minmax(0,1fr)] max-[1100px]:grid-cols-1"
  >
    <div class="flex flex-col">
      <Section plain title="Основные данные" sub="ФИО и идентификатор">
        <div class="grid grid-cols-2 gap-x-5 gap-y-3.5 max-sm:grid-cols-1">
          <ReadonlyField label="Фамилия" :value="data.last_name" />
          <ReadonlyField label="Имя" :value="data.first_name" />
          <ReadonlyField label="Отчество" :value="data.middle_name" />
          <ReadonlyField label="ИИН" :value="data.identifier" />
        </div>
      </Section>
    </div>

    <div class="flex flex-col">
      <Section plain narrow title="Контакты" sub="Email и телефон">
        <div class="flex flex-col gap-3.5">
          <EditableField
            v-if="editMode && canEdit"
            label="Email"
            type="email"
            :model-value="data.email"
            @update:model-value="setField('email', $event)"
          />
          <ReadonlyField v-else label="Email" :value="data.email" />

          <EditableField
            v-if="editMode && canEdit"
            label="Телефон"
            :model-value="data.phone"
            @update:model-value="setField('phone', $event)"
          />
          <ReadonlyField v-else label="Телефон" :value="data.phone" />
        </div>
      </Section>
    </div>
  </div>
</template>
